module.exports = __webpack_public_path__ + "static/media/DeliverySchedule.cca368c6.svg";